import { aiPlanningPlanEntrypoint } from '@jira/spa-apps__ai-planning/src/aiPlanningPlanEntrypoint.entrypoint.tsx';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { softwareAiPlanningPlanRoute } from '@jira/router-routes__software-ai-planning-routes/src/softwareAiPlanningPlanRoute.tsx';
import { createChromelessEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import type { Route } from '@atlassian/react-resource-router';

const aiPlanningSoftwarePlanPageEntrypoint = createChromelessEntryPoint({
	main: aiPlanningPlanEntrypoint,
});

export const softwareAiPlanningPlanRouteEntry: Route = createEntry(
	softwareAiPlanningPlanRoute,
	() => ({
		group: 'software',
		ufoName: 'software-ai-planning-plan',
		layout: { isChromeless: true, globalComponents: [], rightSidebars: [] },
		resources: [],

		meta: {
			reporting: {
				id: 'software-ai-planning-plan',
				packageName: 'jiraRouterRoutesSoftwareAiPlanningEntries',
				teamName: 'Reverie',
			},
		},

		entryPoint: () =>
			fg('jira_ai_planner_tab') ? aiPlanningSoftwarePlanPageEntrypoint : notFoundPageEntrypoint,

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
